import Core from "@/modules/core/service/Core";
import Inc from "@/modules/inc/service/Inc";

export default  {
    props: {
        height: {

        },

        topHeight: {

        },

        customer: {

        },

        all: {

        },

        liftmanagement: {

        }
    },

    data: () => ({
        items           : null,
        loading         : false,
        search          : null,
        filteredItems   : null,
        selectedCustomer: null
    }),

    mounted () {
        this.selectedCustomer = this.customer;
    },

    watch: {
        customer () {
            this.selectedCustomer = this.customer;
            this.doFilter();
        },

        all () {
            if (!this.selectedCustomer) {
                this.initialize();
            }
        },

        liftmanagement () {
            this.doFilter();
        }
    },

    methods: {
        onSearch (search) {
            this.search = search;
            this.doFilter();
        },

        onSite (item) {
            this.$emit("site", item.unitId)
        },

        load (type) {
            this.loading = true;
            Inc.todo.list(type, this.all).then (data => {
                this.items = data;
                this.doFilter();
                this.loading = false;
            });
        },

        doFilter () {
            this.filteredItems = this.items.filter(i => this.match(i));
        },

        match (item) {
            if (this.liftmanagement && !item.liftmanagement) {
                return false;
            }

            if (!this.search) {
                return this.matchCustomer(item)
            }

            if (this.matchCustomer(item)) {
                return this.matchDetails(item)
            }

            return false;
        },

        matchCustomer (item) {
            if (!this.customer) {
                return true;
            }

            return item.customerName === this.customer.name;
        },

        matchDetails (item) {
            if (Core.filter.includes(item.elevatorNo, this.search)) {
                return true;
            }

            if (Core.filter.includes(item.street, this.search)) {
                return true;
            }

            if (Core.filter.includes(item.city, this.search)) {
                return true;
            }

            if (Core.filter.includes(item.typeName, this.search)) {
                return true;
            }

            if (item.incidentId && Core.filter.startsWith(item.incidentId.toString(), this.search)) {
                return true;
            }
            
            return !!Core.filter.includes(item.completeStatus, this.search);
        },
    }
}
